// extracted by mini-css-extract-plugin
export default {"body":"fneBKyi9iU2TOfjBh5Wg","buttons":"VKWiEGGw8nduCW3GdQM8"};